import isFolderOrSubFolderOfDistinguishedFolder from 'owa-mail-store/lib/utils/isFolderOrSubFolderOfDistinguishedFolder';
export var MoveKind;
(function (MoveKind) {
    MoveKind[MoveKind["Normal"] = 0] = "Normal";
    MoveKind[MoveKind["ShadowMailbox_Copy"] = 1] = "ShadowMailbox_Copy";
    MoveKind[MoveKind["ShadowMailbox_Delete"] = 2] = "ShadowMailbox_Delete";
})(MoveKind || (MoveKind = {}));
var isOrUnderJunkOrDeleted = function (folder) {
    return isFolderOrSubFolderOfDistinguishedFolder(folder, 'deleteditems') ||
        isFolderOrSubFolderOfDistinguishedFolder(folder, 'junkemail');
};
export default (function (isShadowMailbox, sourceFolder, destinationFolder) {
    if (!isShadowMailbox) {
        return 0 /* Normal */;
    }
    else if (sourceFolder.sourceWellKnownFolderType == 86 /* AllMail */ &&
        !isOrUnderJunkOrDeleted(destinationFolder)) {
        return 1 /* ShadowMailbox_Copy */;
    }
    else if (!isOrUnderJunkOrDeleted(sourceFolder) &&
        destinationFolder.sourceWellKnownFolderType == 86 /* AllMail */) {
        return 2 /* ShadowMailbox_Delete */;
    }
    else {
        return 0 /* Normal */;
    }
});
//# sourceMappingURL=getMoveKind.js.map